module.exports = __webpack_public_path__ + "static/img/icon_telegram.7aa81d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_telegram.svg
// module id = uc44
// module chunks = 1